import React, { useEffect } from "react";
import { DevTool } from "@/components/dashboard/roadmap/DevToolSelect";
import OpportunitySection from "@/components/dashboard/roadmap/OpportunitySection";
import { Opportunity } from "@/components/dashboard/roadmap/OpportunitySection";

interface RoadmapContentProps {
  allOpportunities: Opportunity[];
  capacity: number;
  devTool: DevTool;
}

const RoadmapContent = ({
  allOpportunities,
  capacity,
  devTool
}: RoadmapContentProps) => {
  
  useEffect(() => {
    console.log("RoadmapContent received capacity:", capacity);
  }, [capacity]);

  return (
    <div className="px-8 pb-8 w-full">
      <OpportunitySection
        key="start-now"
        title="Start Now"
        color="#FF4A8E"
        opportunities={allOpportunities.slice(0, capacity)}
        startIndex={0}
        devTool={devTool}
        capacity={capacity}
      />
      
      <OpportunitySection
        key="next-up"
        title="Next Up"
        color="#FFC921"
        opportunities={allOpportunities.slice(capacity, capacity * 2)}
        startIndex={capacity}
        devTool={devTool}
        capacity={capacity}
      />
      
      <OpportunitySection
        key="start-soon"
        title="Start Soon"
        color="#34AED7"
        opportunities={allOpportunities.slice(capacity * 2, capacity * 3)}
        startIndex={capacity * 2}
        devTool={devTool}
        capacity={capacity}
      />

      {allOpportunities.length > capacity * 3 && (
        <OpportunitySection
          key="start-later"
          title="Start Later"
          color="#62718D"
          opportunities={allOpportunities.slice(capacity * 3)}
          startIndex={capacity * 3}
          borderBottom={false}
          devTool={devTool}
          capacity={capacity}
        />
      )}
    </div>
  );
};

export default RoadmapContent;
